module.exports = __webpack_public_path__ + "static/02-54460085089c002dfe212ff7ad0823ba.jpg";